import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description: string;
  onReset?: () => void;
  resetLabel?: string;
}

export default function EmptyState({
  icon = "ri-emotion-sad-line",
  title,
  description,
  onReset,
  resetLabel = "重置筛选条件",
}: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-background-300 bg-background-100 px-6 py-16 text-center">
      <span className="flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-primary-400">
        <i className={`${icon} text-3xl`} aria-hidden="true"></i>
      </span>
      <h3 className="mt-5 font-heading text-lg font-bold text-foreground-900">{title}</h3>
      <p className="mt-2 max-w-md text-sm leading-relaxed text-foreground-500">{description}</p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        {onReset ? (
          <button
            type="button"
            onClick={onReset}
            className="flex items-center gap-1 rounded-md bg-primary-500 px-4 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-refresh-line" aria-hidden="true"></i>
            {resetLabel}
          </button>
        ) : null}
        <Link
          to="/"
          className="rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 cursor-pointer whitespace-nowrap"
        >
          返回首页
        </Link>
      </div>
    </div>
  );
}